import PropTypes from "prop-types";

import { TransactionDetail } from "./TransactionDetail";

export function TransactionList({
    gameId,
    playerId,
    transactions,
    handleShowAddTransaction,
}) {
    const details = transactions.map((t) => (
        <TransactionDetail
            key={t.id}
            gameId={gameId}
            playerId={playerId}
            transaction={t}
        />
    ));

    return (
        <div className="tx-details">
            <div className="tx-details-head">
                <span>Transactions</span>
                {handleShowAddTransaction && (
                    <button
                        className="accent"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleShowAddTransaction();
                        }}
                    >
                        Add transaction
                    </button>
                )}
            </div>
            {details.length > 0 ? (
                details
            ) : (
                <div className="tx-line">
                    <div />
                    <div className="tx-meta">No transactions yet</div>
                </div>
            )}
        </div>
    );
}

TransactionList.propTypes = {
    gameId: PropTypes.string,
    playerId: PropTypes.string,
    transactions: PropTypes.arrayOf(PropTypes.object),
    handleShowAddTransaction: PropTypes.func,
};
